import { BASE_URL } from "./constants";
import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

const ConnectionsClient = axios.create({});

ConnectionsClient.interceptors.request.use((config) => {
	const contextToken =
		typeof window !== "undefined" && window.__APPLABY_CONTEXT__;
	if (contextToken) {
		config.headers["X-Applaby-Context"] = contextToken;
	}
	return config;
});

ConnectionsClient.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		const message = error?.response?.data?.message;

		if (status === 401 && message === "INVALID_TOKEN") {
			const key = "iframeHasReloaded";
			const stored = sessionStorage.getItem(key);

			const lastReloadTs = stored ? parseInt(stored, 10) : NaN;
			const moreThan1Min =
				!Number.isNaN(lastReloadTs) && Date.now() - lastReloadTs > 60_000;

			if (stored === null || moreThan1Min) {
				sessionStorage.setItem(key, Date.now().toString());
				if (typeof window !== "undefined") {
					window.location.reload();
				}
				return Promise.reject(
					new axios.CanceledError("Reloading due to INVALID_TOKEN")
				);
			}
		}

		return Promise.reject(error);
	}
);

class RequestsClient {
	iframe = true;
	currentAPIURL = BASE_URL + "/";
	iframeURL = "/iframe/";

	type = "AL";

	get = (url, params, type, path) => {
		const finalUrl =
			this.currentAPIURL +
			path +
			this.iframeURL +
			((type || this.type) === "WP" ? "wc/" : "") +
			url;
		console.log(new Date() + " - " + finalUrl);
		return ConnectionsClient.get(finalUrl, params);
	};

	post = (url, params, config, type, path) => {
		const finalUrl =
			this.currentAPIURL +
			path +
			this.iframeURL +
			((type || this.type) === "WP" ? "wc/" : "") +
			url;
		console.log(new Date() + " - " + finalUrl);
		return ConnectionsClient.post(finalUrl, params, config);
	};

	put = (url, params, config, type, path) => {
		const finalUrl =
			this.currentAPIURL +
			path +
			this.iframeURL +
			((type || this.type) === "WP" ? "wc/" : "") +
			url;
		console.log(new Date() + " - " + finalUrl);
		return ConnectionsClient.put(finalUrl, params, config);
	};

	delete = (url, params, config, type, path) => {
		const finalUrl =
			this.currentAPIURL +
			path +
			this.iframeURL +
			((type || this.type) === "WP" ? "wc/" : "") +
			url;
		console.log(new Date() + " - " + finalUrl);
		return ConnectionsClient.delete(finalUrl, params, config);
	};

	login = (url, params, type, path) => {
		return ConnectionsClient.post(
			this.currentAPIURL + path + this.iframeURL + url,
			params
		);
	};
}

export const requestsClient = new RequestsClient();
